import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export function deleteAdminAction(id: number): Promise<ApiResponse<any>> {
  return api.delete<ApiResponse<any>>(`/admins/${id}`)
}
